<template>
  <el-dialog title="会员角色" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small">
      <el-form-item label="角色">
        <el-checkbox-group v-model="checkedRole">
          <el-checkbox v-for="(item,index) in allRole" :label="item.value" :key="index" border>{{item.name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data () {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        allRole: [],
        checkedRole: []
      };
    },
    props: ['open_role', 'form'],
    created () {
      this.dialogVisible = this.open_role;
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData () {
        let self = this;
        UserApi.toEditRole({
          userId: self.form.userId,
          productId: self.form.productId
        }, true)
          .then(res => {
            self.allRole = res.data.allRole;
            self.checkedRole = res.data.userRole;
          })
          .catch(error => { });
      },
      /*添加用户*/
      onSubmit () {
        let self = this;
        self.loading = true;
        UserApi.editRole({
          userId: self.form.userId,
          productId: self.form.productId,
          checkedRole: self.checkedRole
        }, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，修改成功',
              type: 'success'
            });
            self.dialogFormVisible(true);
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*关闭弹窗*/
      dialogFormVisible (e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/user/dialog/Role.vue